import { create } from 'zustand'
import { formularioSlice } from './slices/formularioSlice'
import { sucursalesSlice } from './slices/sucursalesSlice'
import { promocionesSlice } from './slices/promocionesSlice'

const usePromocionesStore = create((set,get) => ({
    error:null,
    isLoading: true,
    elNavigate:null,
    datos: {
        id:0,
        nombre:"",
        texto_uno:"",
        texto_dos:"",
        hexFondo:"#EA6852",
        hexTexto:"#ffffff",
        imagen:"",
        esDetalle:true,
        detalle:"",
        sucursales:[],
        estatus:1
    },
    fileImagen: null,
    imagen:"",
    setHexFondo: (hex) => set({datos:{ ...get().datos, hexFondo: hex }}),
    setHexTexto: (hex) => set({datos:{ ...get().datos, hexTexto: hex }}),
    setNavigate: (navigate) => set({ elNavigate: navigate }),
    actualizarId: (id) => set({ datos: { ...get().datos, id } }),
    handleImagen: (e) => set({ imagen: e.target.files.base64, fileImagen: e.target.files.originalFile, datos:{ ...get().datos, imagen: e.target.files.originalFile.name } }),
    limpiarImagen: () => set({ imagen: "", fileImagen: null, datos:{ ...get().datos, imagen: "" } }),
    handleSave: () => get().insertarPromocion(),
    handleSucursales: (e) => set({ datos: { ...get().datos, sucursales: e } }),
    iniciar: async() => {
        await get().obtenerSucursales();
        await get().obtenerPromocion();
        set({ isLoading: false });
    },
    limpiar: () => {
        set({
            isLoading: true,
            datos: {
                id:0,
                nombre:"",
                texto_uno:"",
                texto_dos:"",
                hexFondo:"#EA6852",
                hexTexto:"#ffffff",
                imagen:"",
                esDetalle:true,
                detalle:"",
                sucursales:[],
                estatus:1
            },
            fileImagen: null,
            imagen:"",
            elNavigate:null,
            error:null,
        })
    },
    ...formularioSlice(set,get),
    ...sucursalesSlice(set,get),
    ...promocionesSlice(set,get)
}))
  
export default usePromocionesStore
